import defu from "defu";
import { UseFetchOptions } from "nuxt/app";
import { RuntimeConfig } from "nuxt/schema";

export const useAnonymousApi = <T>(url: string | (() => string), options: UseFetchOptions<T> = {}) => {
  const errorStore = useErrorStore()
  const config: RuntimeConfig = useRuntimeConfig()

  const defaults: UseFetchOptions<T> = {
    baseURL: `${config.public.API_URL}/v1`,
    headers: { Accept: 'application/json' },
  }

  return useFetch(url, defu(options, defaults))
}
